import { NodeSpec } from 'prosemirror-model';

import { BaseExtension, PerformanceType } from '@lyearn/lygo-core';

import { NODE_NAME } from './consts';
import plugins from './plugins';

export default class Embed extends BaseExtension {
  get schema(): NodeSpec {
    return {
      attrs: {
        href: {
          default: null,
        },
        name: {
          default: null,
        },
        type: {
          default: null,
        },
        size: {
          default: null,
        },
        file: {
          default: null,
        },
        embedUrl: {
          default: null,
        },
        srcDoc: {
          default: null,
        },
        // In percentage.
        width: {
          default: 40,
        },
        // width is to height
        aspectRatio: {
          default: null,
        },
        //conversion job
        jobToken: {
          default: null,
        },
        title: {
          default: null,
        },
        description: {
          default: null,
        },
        redirectLink: {
          default: null,
        },
      },
      group: 'block',
      isAtom: true,
      parseDOM: [
        {
          tag: 'div.lygo-embed',
          getAttrs: (dom) => {
            const file = (dom as HTMLElement).getElementsByTagName('iframe')[0];
            return {
              href: file.getAttribute('href'),
              name: file.getAttribute('name'),
              type: file.getAttribute('type'),
              size: file.getAttribute('size'),
            };
          },
        },
      ],
      toDOM: (node) => {
        let href = node?.attrs?.href;
        return href
          ? ['div', { class: 'flex justify-center mt-16 lygo-file' }, ['a', { ...node.attrs }]]
          : ['div'];
      },
    };
  }

  get name(): string {
    return NODE_NAME;
  }

  get performanceType(): PerformanceType {
    return PerformanceType.BLOCK_BASED;
  }

  plugins = plugins;
}
